module.exports = __webpack_public_path__ + "img/ico-1-active.7829fef6.svg";